export function isUserGetMediaSupported(): boolean {
  if (typeof navigator !== 'undefined') {
    const nav = navigator

    return !!nav.getUserMedia || (!!nav.mediaDevices && !!nav.mediaDevices.getUserMedia)
  }

  return false
}
